export default __webpack_public_path__ + "static/media/OCTAPAD.81090506.jpg";